module.exports = __webpack_public_path__ + "static/ageNoticeImage-3384dfbbb3183cde877b365eb46ee639.png";